import FeatureImage from "../../assets/images/Features-graphic.png";
import AnnotatedSlidesIcon from "../../assets/icons/annotated_slides.svg";
import Container from "react-bootstrap/esm/Container";
import QuizIcon from "../../assets/icons/quiz.svg";
import SchoolIcon from "../../assets/icons/school.svg";
import EmbeddableFiguresIcon from "../../assets/icons/embeddable_figures.svg";

function DeeperLookComponent(){

    return(
        <>
                        <Container>
                  <h1
                    align={"center"}
                    style={{ padding: "4%", fontSize: "54px", color: "#5a5a5a" }}
                  >
                    Take A Look Inside.
                  </h1>
        
                  <h1 style={{ fontWeight: "bold" }}></h1>
                  <div
                    style={{
                      display: "flex",
                      alignContent: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img width="90%" src={FeatureImage}></img>
                  </div>
        
                  <h2 style={{ fontWeight: "bold", textAlign: "center" }}>
                    Additional instructor resources available
                  </h2>
                  <br />
                  <br />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "horizontal",
                      justifyContent: "center",
                    }}
                  >
                    <div style={{display: 'flex'}}>
                      <h4>
                        <ul className="feature_list">
                          <li>
                            <img className="feature_icon" src={AnnotatedSlidesIcon} />{" "}
                            Annotated Slides
                          </li>
                          <li>
                            <img className="feature_icon" src={EmbeddableFiguresIcon} />{" "}
                            Embeddable Figures
                          </li>
                          
                        </ul>
                      </h4>
                      <h4>
                        <ul className="feature_list">
                        <li>
                            <img className="feature_icon" src={QuizIcon} /> Instructor
                            Dashboard
                          </li>
                          <li>
                            <img className="feature_icon" src={SchoolIcon} />
                            High-school Teacher Guide
                          </li>
                          
                        </ul>
                      </h4>
                    </div>
                    <div></div>
                  </div>
                </Container>
        </>
    )
}

export default DeeperLookComponent;
